/**
 * Format price
 * @param price - Price
 * @returns Formatted price
 */
export const formatPrice = (price: number | null): string => {
	if (price === null || price === undefined) {
		return '-'
	}

	return `${price} €`
}
